import React, { useContext } from 'react';
import { IDishesContext, DishesContext } from '../../../dishesState/dishesContext';
import Text from 'components/Text/Text';
import { Item } from './Item';
import classNames from 'classnames';
import style from './index.module.scss';

export const DishesByRestaurantList: React.FC = () => {
	const { dishesByRestaurant } = useContext<IDishesContext>(DishesContext);

	const dishHeadingClasses = classNames(style.dish, style.heading);
	const articleNumberHeadingClasses = classNames(style.articleNumber, style.heading);
	const categorySubcategoryHeadingClasses = classNames(style.categorySubcategory, style.heading);
	const stopStatusHeadingClasses = classNames(style.stopStatus, style.heading);
	const priceHeadingClasses = classNames(style.price, style.heading);
	const externalIdHeadingClasses = classNames(style.externalId, style.heading);
	const hasPortionsHeadingClasses = classNames(style.hasPortions, style.heading);
	const actionHeadingClasses = classNames(style.action, style.heading);

	return (
		<div className={style.container} data-test="List">
			<div className={style.tableHeaders}>
				<Text
					className={dishHeadingClasses}
					translationNameSpace="listing"
					translationKey="dishLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={articleNumberHeadingClasses}
					translationNameSpace="listing"
					translationKey="articleNumberLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={categorySubcategoryHeadingClasses}
					translationNameSpace="listing"
					translationKey="categorySubcategoryLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={stopStatusHeadingClasses}
					translationNameSpace="listing"
					translationKey="stopStatusLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={priceHeadingClasses}
					translationNameSpace="listing"
					translationKey="priceLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={externalIdHeadingClasses}
					translationNameSpace="listing"
					translationKey="externalIdLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={hasPortionsHeadingClasses}
					translationNameSpace="listing"
					translationKey="portionsLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={actionHeadingClasses}
					translationNameSpace="listing"
					translationKey="actionLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
			</div>
			{dishesByRestaurant.items.map((item, index) => (
				<Item data={item} key={item.id + 'list'} index={index} />
			))}
		</div>
	);
};
